import React, { Component } from 'react';
import Switch from '../Part_Sample/Switch';
import { getModeIcon } from '../Common/Common';

export default class Command_Mode extends Component {
	constructor(props) {
		super(props);

		let modes = ['C', 'H', 'F', 'D', 'A'];
		if (this.props.point_info != null) {
			let temp_modes = [];
			for (var i = 0; i < modes.length; i++) {
				if (this.props.point_info.mode_cap[modes[i]] != null) {
					temp_modes.push(modes[i]);
				}
			}
			modes = temp_modes;
		}

		this.modes = modes;
		this.state = {
			is_enabled: this.props.action_details.mode != null ? true : false,
			mode: this.props.action_details.mode != null ? this.props.action_details.mode : 'C'
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.mode != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let mode = nextProps.action_details.mode != null ? nextProps.action_details.mode : 'C';

		if (mode != nextState.mode) {
			this.setState({
				mode: mode
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !(this.props.action_details.mode != null ? true : false)
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeMode(this.state.mode);
		} else {
			this.props.handleChangeMode(null);
		}
	}

	handleOnClick = () => {
		if (this.state.is_enabled) {
			let new_mode = 'C';

			let mode = this.state.mode;

			let index = this.modes.indexOf(mode);
			if (index === this.modes.length - 1) new_mode = this.modes[0];
			else new_mode = this.modes[index + 1];

			this.setState({ mode: new_mode });

			this.props.handleChangeMode(new_mode);
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		let icon = getModeIcon(this.state.mode);

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 120 }}>
					<span>{this.props.receiver.getString('mode')}</span>
				</div>
				<div style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'top' }} onClick={this.handleOnClick}>
					<img src={icon} style={{ width: 25, }} />
				</div>
			</div>
		)
	}
}